/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./plugins/global-mixin');

window.Vue = require('vue');

window.events = new Vue();

window.flash = function(message) {
    window.events.$emit('flash',message);
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Common
Vue.component('paging', require('./components/Common/Paging').default)
Vue.component('modal-select-search', require('./components/Common/ModalSelectSearch').default)
Vue.component('select-search', require('./components/Common/SelectSearch').default)

//Job
Vue.component('list-job-detail', require('./components/Job/ListItemDetail').default)
Vue.component('job-detail', require('./components/Job/Detail').default)
Vue.component('job-detail-card', require('./components/Job/ItemDetailCard').default)

//Mypage
Vue.component('mypage-skill-card', require('./components/MyPage/SkillCard').default)
Vue.component('user-password', require('./components/MyPage/Password').default)
Vue.component('user-info', require('./components/MyPage/Info').default)
Vue.component('upload-skillsheet', require('./components/MyPage/PanelUpload').default)

//User
Vue.component('form-user-register', require('./components/User/RegisterForm').default)

//Contact
Vue.component('contact', require('./components/Contact/SendMailContactForm').default)
//Business
Vue.component('business', require('./components/Business/FormBusinessSendMail').default)

//Flash
Vue.component('flash', require('./components/Flash.vue').default)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
